<template>
  <section>
    <!--<v-container fluid >-->
      <div class="box">
        <div v-for="(k, index) in kenkaku" :key="index">
          <browse-build :gaiyo="k" />
        </div>
      </div>
    <!--</v-container>-->
  </section>
</template>

<script>
import { CallApi } from '../common/apiAccess';
import BrowseBuild from '../components/BrowseBuild.vue'

export default {
  components: {
    BrowseBuild,
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    kenkaku () {
      const arr = this.$store.state.printList;
      if (arr === null || arr.length == 0) {
        return [];
      }
      else {
        //return arr.sort((a, b) => a.ukeNo > b.ukeNo ? 1 : -1);
        return arr;
      }
    },
  },
  mounted () {
    this.$store.commit('setPrinting', true);
    setTimeout(() => {
      for (let i = 0; i < this.kenkaku.length; i++) {
        try {
          CallApi('RegistLog',
            { actionCode:102, actionName:'建築計画概要書印刷',
              clientIp: this.$store.state.clientInfo.clientIp,
              userId: this.$store.state.userInfo.id,
              userName: this.$store.state.userInfo.userName,
              ukeNo:this.kenkaku[i].ukeNo, kknnNo:this.kenkaku[i].kknnNo },
            (data) => {
              if (data.errorCode) {
                console.log(`regist log error: (print) ${data.errorCode}`);
              }
          });
        }
        catch (err) {
          console.log(err);
        }
      }
      window.print();
      this.$store.commit('setPrinting', false);
      this.$store.commit('clearePrintList');
      this.$router.back();
    }, 3000);
  },
}
</script>

<style lang="scss" scoped>
* {
  padding: 0;
}
section {
  margin: 0;
  padding: 0;
}
@media print {
  @page {
    //size: A4 portrait !important;
    size: auto !important;
    margin: 0mm;
  }
  .box {
    //width: 200mm;
    //height: auto;
    //width: calc(210mm - 16mm);
    height: calc(296m - 36mm);
    //width: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
}
</style>
